// mulberry32 — tiny seedable RNG whose state lives inside GameState so the
// sim stays deterministic and replayable (pattern borrowed from the spy project).

export function rngNext(state: { rngState: number }): number {
  state.rngState = (state.rngState + 0x6d2b79f5) | 0;
  let t = state.rngState;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}
